<template>
  <Modal v-model="associationOperationModal" :title="associationOperationTitle" width="500" :transfer="false"
    class-name="commonModalStyles" :mask-closable="false" @on-visible-change="associationOperationChange">
    <!--关联合规责任人-->
    <template v-if="associationOperationType === 'personInCharge'">
      <div class="flex align-items-center mb15" v-for="item in responsibleAreaList">
        <p>{{ item.name + $t('key1000281') }}</p>
        <Select v-model="item.selectYmsCompliancePersonId" style="width:250px;">
          <Option v-for="k in personInChargeList.filter(ele => ele.zoneCode === item.zoneCode)" :value="k.ymsCompliancePersonId">
            {{ k.name }}
          </Option>
        </Select>
      </div>
    </template>
    <!--关联制造商-->
    <template v-else>
      <div class="flex align-items-center mb15" v-for="item in responsibleAreaList">
        <p>{{ item.name + $t('key1000282') }}</p>
        <Select v-model="item.selectYmsManufacturerInfoId" style="width:250px;">
          <Option v-for="k in manufacturerData" :value="k.ymsManufacturerInfoId">{{ k.name }}</Option>
        </Select>
      </div>
    </template>
    <div class="flex align-items-center wid100P justify-content-center mt20 font-size-13">
      <span>{{ optionsName }}</span>
      <span class="cursor distributorThemeColor" @click="redirectPage">{{ $t('key1000283') }}</span>
    </div>
    <template #footer>
      <Button class="mr15" @click="associationOperationModal = false">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" :disabled="disabledTalg" @click="associationOperationBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {commonLocalStorage, getAllPersonInChargeData, getCountryZoneData, getAllManufacturerData} from '@/utils/common';
import api from '@/api/';

export default {
  name: 'associationOperationModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      associationOperationModal: false,
      associationOperationTitle: '',
      associationOperationType: null,
      ymsProductId: null,
      responsibleAreaList: [],
      personInChargeList: [],
      ymsCompliancePersonId: null,
      ymsManufacturerInfoId: null,
      manufacturerData: [],
    };
  },
  computed: {
    disabledTalg() {
      if (this.associationOperationType === 'personInCharge') {
        return !this.responsibleAreaList.some(item => item.selectYmsCompliancePersonId);
      } else {
        return !this.responsibleAreaList.some(item => item.selectYmsManufacturerInfoId);
      }
    },
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    optionsName() {
      return this.associationOperationType === 'personInCharge' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000276') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000277');
    }
  },
  methods: {
    // 初始化数据
    initAssociationOperationData(type, ymsProductId, idList = []) {
      this.ymsProductId = ymsProductId;
      getCountryZoneData().then((data) => {
        this.responsibleAreaList = data.map((item) => {
          return {
            ...item,
            selectYmsCompliancePersonId: null,
            selectYmsManufacturerInfoId: null,
          };
        });
        
        this.associationOperationType = type;
        if (type === 'personInCharge') {
          this.associationOperationTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000278');
          getAllPersonInChargeData().then((data) => {
            this.personInChargeList = data;
            if (idList.length > 0) {
              this.responsibleAreaList.map((item) => {
                idList.map((ele) => {
                  if (item.zoneCode === ele.zoneCode) {
                    item.selectYmsCompliancePersonId = ele.ymsCompliancePersonId;
                  }
                });
              });
            }
          });
        } else {
          this.associationOperationTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000279');
          getAllManufacturerData().then((data) => {
            this.manufacturerData = data;
            if (idList.length > 0) {
              this.responsibleAreaList.map((item) => {
                idList.map((ele) => {
                  if (item.zoneCode === ele.zoneCode) {
                    item.selectYmsManufacturerInfoId = ele.ymsManufacturerInfoId;
                  }
                });
              });
            }
          });
        }
        this.associationOperationModal = true;
      });
    },
    // 确定按钮
    associationOperationBtn() {
      let list = [];
      switch (this.associationOperationType) {
        case 'personInCharge':
          this.responsibleAreaList.forEach(item => {
            if (item.selectYmsCompliancePersonId) {
              list.push({
                ymsProductId: this.ymsProductId,
                ymsCompliancePersonId: item.selectYmsCompliancePersonId,
                zoneCode: item.zoneCode,
                ymsDistributorMerchantId: this.userInfo.merchantId
              });
            }
          });
          this.axios.post(api.post_ymsDistributorProductInfo_insertCompliancePersonProducts,
            list, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000280'));
              this.associationOperationModal = false;
              this.$emit('updateData', true);
            }
          });
          break;
        case 'manufacturer':
          this.responsibleAreaList.forEach(item => {
            if (item.selectYmsManufacturerInfoId) {
              list.push({
                ymsProductId: this.ymsProductId,
                ymsManufacturerInfoId: item.selectYmsManufacturerInfoId,
                zoneCode: item.zoneCode,
                ymsDistributorMerchantId: this.userInfo.merchantId
              });
            }
          });
          this.axios.post(api.post_ymsDistributorProductInfo_insertManufacturerProduct, list, {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000280'));
              this.associationOperationModal = false;
              this.$emit('updateData', true);
            }
          });
          break;
      }
    },
    // 跳转页面
    redirectPage() {
      // 打开新窗口跳转
      if(this.associationOperationType === 'personInCharge') {
        const {href} = this.$router.resolve({
          path: '/complianceResponsiblePersonList'
        });
        commonLocalStorage.setItem('autoCreate', 'Y');
        setTimeout(() => {
          window.open(href, '_blank');
        }, 1000);
      } else {
        const {href} = this.$router.resolve({
          path: '/manufacturerInfoList'
        });
        commonLocalStorage.setItem('autoCreate', 'Y');
        setTimeout(() => {
          window.open(href, '_blank');
        }, 1000);
      }
    },
    // 监听弹窗
    associationOperationChange(value) {
      if (!value) {
        this.ymsProductId = null;
        this.responsibleAreaList = [];
        this.personInChargeList = [];
        this.ymsCompliancePersonId = null;
        this.ymsManufacturerInfoId = null;
        this.manufacturerData = [];
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>
